import Container from './DetailCategoryContainer'


export default Container